.skeleton {
  display: block;
  background:
    linear-gradient(
      90deg,
      var(--color-skeleton) 0%,
      var(--color-skeleton-shine) 50%,
      var(--color-skeleton) 100%
    )
    0 0 / 200% 100%;
  animation: shimmer 1.4s ease-in-out infinite;
}

.text {
  height: 0.9em;
  border-radius: var(--radius-xs);
}

.title {
  height: 1.4em;
  border-radius: var(--radius-sm);
}

.block {
  width: 100%;
  height: 100%;
  border-radius: var(--radius-lg);
}

.circle {
  aspect-ratio: 1;
  border-radius: var(--radius-full);
}

.control {
  height: var(--control-md);
  border-radius: var(--radius-md);
}

@keyframes shimmer {
  from {
    background-position: 100% 0;
  }
  to {
    background-position: -100% 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .skeleton {
    animation: none;
  }
}
